import { render, staticRenderFns } from "./OperationalArea.vue?vue&type=template&id=2c4da20a"
import script from "./OperationalArea.vue?vue&type=script&lang=js"
export * from "./OperationalArea.vue?vue&type=script&lang=js"
import style0 from "./OperationalArea.vue?vue&type=style&index=0&id=2c4da20a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports